export enum HaptikEventName {
  HAPTIK_APP_LOADED = 'HAPTIK_APP_LOADED',
  HAPTIK_CHAT_BUTTON_HOVERED = 'HAPTIK_CHAT_BUTTON_HOVERED',
  HAPTIK_APP_EXPANDED = 'HAPTIK_APP_EXPANDED',
  HAPTIK_APP_MINIMIZED = 'HAPTIK_APP_MINIMIZED',
  HAPTIK_MESSAGE_RECEIVED = 'HAPTIK_MESSAGE_RECEIVED',
  HAPTIK_LANGUAGE_ICON_CLICKED = 'HAPTIK_LANGUAGE_ICON_CLICKED',
  HAPTIK_LANGUAGE_SELECTED = 'HAPTIK_LANGUAGE_SELECTED',
  HAPTIK_BUTTON_CLICKED = 'HAPTIK_BUTTON_CLICKED',
}
